import { render, staticRenderFns } from "./WarengruppenComponent.vue?vue&type=template&id=2d9ed8c2&"
import script from "./WarengruppenComponent.vue?vue&type=script&lang=js&"
export * from "./WarengruppenComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports